import { Link } from "react-router-dom";
import { useT } from "@/i18n/I18nContext";
import MovixLogo from "@/components/MovixLogo";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancelled() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
      <div className="absolute top-6 left-6"><MovixLogo variant="light" showTagline={false} size="md" /></div>
      <div className="max-w-md w-full text-center space-y-6">
        <XCircle className="w-20 h-20 mx-auto text-red-500" />
        <h1 className="font-display font-black text-4xl tracking-tighter">{t("billing.paymentCancelled")}</h1>
        <p className="text-white/70">{t("billing.paymentCancelledMsg")}</p>
        <Link to="/" className="inline-flex items-center gap-2 px-5 py-2 border border-white/20 hover:bg-white/10 transition-colors">
          <ArrowLeft className="w-4 h-4" /> {t("billing.backToApp")}
        </Link>
      </div>
    </div>
  );
}
